<template>
  <master-crud-page
    master="asset_type"
    title="Asset Type"
    access="master_asset_type"
    pk="matyId"
    :columns="columns"
    :fields="fields"
  />
</template>

<script>
import MasterCrudPage from '@/components/master/MasterCrudPage';
import { formatDateTime } from '@/util/date';
import { DISPLAY_DATE } from '@/util/apiDatetime';

export default {
  name: 'MasterAssetType',
  components: { MasterCrudPage },
  data() {
    return {
      columns: [
        { key: 'matyName', label: 'Asset Type Name', align: 'left' },
        { key: 'matyCreatedUserId', label: 'Created By', align: 'center' },
        {
          key: 'matyCreatedTime',
          label: 'Created',
          align: 'center',
          formatter: (value) => formatDateTime(value, DISPLAY_DATE),
        },
      ],
      fields: [
        {
          key: 'matyName',
          label: 'Asset Type Name',
          type: 'text',
          required: true,
        },
      ],
    };
  },
};
</script>
